const runtimeConfig = window.__APP_CONFIG__ || {};
const viteConfig = import.meta.env || {};

const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

const normalizeBaseUrl = (value, fallback = "") => {
  if (typeof value !== "string") {
    return fallback;
  }

  const trimmed = value.trim();

  if (!trimmed) {
    return fallback;
  }

  return trimTrailingSlash(trimmed);
};

const preferRuntime = (runtimeValue, viteValue, fallback = "") =>
  normalizeBaseUrl(runtimeValue, normalizeBaseUrl(viteValue, fallback));

export const appConfig = {
  authServerUrl: preferRuntime(
    runtimeConfig.AUTH_SERVER_URL,
    viteConfig.VITE_AUTH_SERVER_URL,
    "http://localhost:9000",
  ),
  accountsServiceUrl: preferRuntime(
    runtimeConfig.ACCOUNTS_SERVICE_URL,
    viteConfig.VITE_ACCOUNTS_SERVICE_URL,
    "http://localhost:8081",
  ),
  guruUrl: preferRuntime(runtimeConfig.GURU_URL, viteConfig.VITE_GURU_URL, ""),
  tagsUrl: preferRuntime(runtimeConfig.TAGS_URL, viteConfig.VITE_TAGS_URL, ""),
  apiBasePath: runtimeConfig.API_BASE_PATH || "api",
};
